import ModalWrapper from 'dashboard/components/ModalWrapper';
import ConfirmationModal from 'dashboard/components-lib/ConfirmationModal';

interface RemoveDeviceModalProps {
  removeDeviceModal: boolean;
  handleRemoveDeviceAndClose: () => void;
  hideRemoveDeviceModal: () => void;
}
const AccountRemoveDeviceModal = ({
  removeDeviceModal,
  handleRemoveDeviceAndClose,
  hideRemoveDeviceModal,
}: RemoveDeviceModalProps) => {
  return (
    <ModalWrapper isOpen={removeDeviceModal} handleCloseModal={hideRemoveDeviceModal}>
      <ConfirmationModal
        cancelAction={hideRemoveDeviceModal}
        confirmAction={handleRemoveDeviceAndClose}
        header='Untrust Device?'
        confirmActionText='Untrust'
      >
        This device will no longer be considered trusted by this account.
      </ConfirmationModal>
    </ModalWrapper>
  );
};

export default AccountRemoveDeviceModal;
